import { Link } from 'react-router-dom';
import { Building2, Mail } from 'lucide-react';
import Footer from '@/components/Footer';

const AboutSpesvest = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-card">
        <div className="container mx-auto px-6 py-4">
          <Link
            to="/"
            className="text-2xl font-bold text-capledger-teal hover:opacity-80 transition-opacity"
          >
            CapLedger
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="space-y-8">
          {/* Title Section */}
          <div className="space-y-4">
            <h1 className="text-4xl font-bold text-foreground">About Spesvest</h1>
            <div className="text-sm text-muted-foreground">
              <strong>Entity:</strong> Spesvest (Pty) Ltd (Registration No. 2016/197925/07)
            </div>
            <div className="text-sm text-muted-foreground">
              <strong>Address:</strong> Unit C, Doornbosch Centre, Strand Rd, Stellenbosch, South
              Africa, 7600
            </div>
          </div>

          {/* Content */}
          <div className="prose prose-slate max-w-none space-y-8">
            {/* Company Overview */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Company Overview</h2>
              <p className="text-muted-foreground leading-relaxed">
                <strong>Spesvest (Pty) Ltd</strong> (Reg. No. 2016/197925/07) is a privately held
                South African investment and technology company based in Stellenbosch.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                The group holds interests in healthcare, property, and retail, and develops digital
                platforms that enhance governance, compliance, and operational efficiency across its
                portfolio.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Spesvest operates from South Africa and collaborates with partners internationally
                in technology and investment ventures.
              </p>
            </section>

            {/* CapLedger Platform */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">CapLedger Platform</h2>
              <p className="text-muted-foreground leading-relaxed">
                <strong className="text-capledger-teal">CapLedger</strong> is one of our flagship
                software products, created to simplify equity and corporate record management for
                growing companies.
              </p>
            </section>

            {/* Contact Section */}
            <section className="space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">Contact Information</h2>
              <div className="bg-muted p-6 rounded-lg space-y-2">
                <p className="font-semibold text-foreground">Spesvest (Pty) Ltd</p>
                <p className="text-muted-foreground">
                  Unit C, Doornbosch Centre, Strand Rd, Stellenbosch, South Africa, 7600
                </p>
                <p className="text-muted-foreground text-sm">Registration No. 2016/197925/07</p>
                <a
                  href="mailto:hello@capledger.co.za"
                  className="flex items-center gap-2 text-capledger-teal hover:underline"
                >
                  <Mail className="h-4 w-4" />
                  hello@capledger.co.za
                </a>
              </div>
            </section>
          </div>

          {/* Company Badge */}
          <div className="flex items-center justify-center gap-3 p-6 bg-muted/50 rounded-lg border border-border">
            <Building2 className="h-6 w-6 text-capledger-teal" />
            <span className="text-sm text-muted-foreground">
              Established 2016 · Stellenbosch, South Africa
            </span>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AboutSpesvest;
